import { render, staticRenderFns } from "./albumForm.vue?vue&type=template&id=7a50d3d2&scoped=true&lang=html&"
import script from "./albumForm.vue?vue&type=script&lang=js&"
export * from "./albumForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a50d3d2",
  null
  
)

export default component.exports